import { RateAdjusters } from "@eave/shared/types/api";

export interface Rate {
  daily_base_rate: string;
  daily_base_rate_date: string;
  displayed_loan_rate: string;
  qualifying_rate: string;
  footnote_loan_rate: string;
  index: string;
  index_text: any;
  margin: string;
  caps: string;
  determined: boolean;
  rate_adjusters: { [k in RateAdjusters]: string };
  loan_program: string;
  loan_type: string;
  downpayment: string;
  fico: number;
  ltv: string;
  price_exception_amount: number;
  price_exception_reason: PriceExceptionReason;
  price_delta: string;
}

export interface LoanApplicationRate {
  id: number;
  rate: string;
  locked: boolean;
  expires_at: string;
  locked_at: string;
  price_exception: null | PriceException;
  created_at: string;
  rate_basis: Rate;
}

export type lockPeriods = "15" | "30" | "45" | "60" | "75" | "90";
export interface RateTables {
  id: number;
  loan_program_id: number;
  lock_periods: { [key in lockPeriods]: { rate: string; price: string; par: boolean }[] };
  created_at: string;
}

export interface PriceException {
  reason: PriceExceptionReason;
  value: string;
  loan_application_id: number;
  loan_application_rate_id: number | null; // will be set if associated to a locked loan application rate
  updated_by_id: number;
  created_at: string;
  updated_at: string;
}

export interface UpdateLockedRateRequest {
  recalculate_adjusters: boolean;
  price_exception: UpdatePriceException | null;
}

export interface UpdatePriceException {
  value: number;
  reason: PriceExceptionReason;
}

export enum PriceExceptionReason {
  PriceExceptionReasonCompetitiveOffer = "Meet a competitive offer",
  PriceExceptionReasonRenegotiation = "Renegotiation after rate lock",
  PriceExceptionReasonCustomerService = "Address customer service issue or operational error",
  PriceExceptionReasonAvoidHighCostLoan = "Needed to avoid High Cost Loan",
  PriceExceptionReasonChangeInLoanParams = "Change in loan parameters after lock",
  PriceExceptionReasonNetTangibleBenefit = "Needed to meet net tangible benefit test",
}
